"use client";

import React from "react";
import { Link } from "@/components/common/Link";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { AspectRatio } from "@/components/ui/aspect-ratio";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const commodities = [{
  title: "Industrial Bovine & Sheep Tallow",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/industrial_tallow_processing.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/industrial_tallow_processing.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/industrial_tallow_processing.png-wvc-sizes",
  alt: "Industrial Tallow Processing Facility",
  link: "/IndustrialBovineAndSheepTallowPage"
}, {
  title: "Used Cooking Oil (UCO)",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/uco_storage_tanks.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/uco_storage_tanks.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/uco_storage_tanks.png-wvc-sizes",
  alt: "UCO Storage Tanks at Port",
  link: "/UsedCookingOilPage"
}, {
  title: "Plant-Based Oil",
  src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/plant_oil_refinery.png",
  srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/plant_oil_refinery.png-wvc-srcset",
  sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1667719/img/plant_oil_refinery.png-wvc-sizes",
  alt: "Plant-Based Oil Refinery",
  link: "/PlantBasedOilPage"
}];
export default function CoreCommodities() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}